import Vue from 'vue';
import VueRouter from 'vue-router';

import Home from '@/views/home/index';
import loginPage from '@/views/layout/index'; 
import History from '@/views/history/index';
import Compare from '@/views/compare/index';
import Results from '@/views/results/index';
import Favs from '@/views/favs/index';
import Calendar from '@/views/calendar/index';
// import Charts from '@/views/charts/index';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      layout: 'admin'
    }
  }, 
  {
    path: '/calendar',
    name: 'Calendar',
    component: Calendar,
    meta: {
      layout: 'admin'
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: loginPage,
    meta: {
      layout: 'public'
    }
  },
  {
    path: '/history',
    name: 'History',
    component: History,
    meta: {
      layout: 'admin'
    }
  },
  {
    path: '/compare',
    name: 'Compare',
    component: Compare,
    meta: {
      layout: 'admin'
    }
  },
  {
    path: '/results/:id',
    name: 'Results',
    component: Results,
    meta: {
      layout: 'admin'
    }
  },
  {
    path: '/favorites',
    name: 'Favs',
    component: Favs,
    meta: {
      layout: 'admin'
    }
  },
  // {
  //   path: '/charts',
  //   name: 'Charts',
  //   component: Charts,
  //   meta: {
  //     layout: 'charts'
  //   }
  // }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
}); 

export default router;